import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Layout from "components/layout";
import { RegisterButton } from "components/registerButton";
import { bindActionCreators } from "redux";
import { Creators as LocationActions } from "store/location/location-duck";
import { IItems } from "store/location/location-model";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData, MenuItemActive } from "store/user-session/user-session-model";
import TokenService from "utils/auth/Token.service";
import useTranslation from "utils/hooks/useTranslation";
import LocationFilter from "./filter";
import LocationGrid from "./grid";
import * as S from "./styled/index.styled";

interface IPropsScreenLocations {
  isLoading?: boolean;
  isLoadingTable?: boolean;
  items?: Array<IItems>;
  totalItems?: number;
  searchFilter?: string;
  pageIndex?: number;
  userData?: IUserData;
}
interface IDispatchProps {
  locationsCreateActive?: (...args) => void;
  locationsFetchRegisterAsync?: (...args) => void;
  locationsChangeFieldValue?: (...args) => void;
  locationsUpdateFilter?: (...args) => void;
  userSessionMenuItemActive?: (...args) => void;
}

type IProps = IPropsScreenLocations & IDispatchProps;

const Location = ({
  isLoading,
  isLoadingTable,
  userData,
  items,
  totalItems,
  searchFilter,
  pageIndex,
  locationsCreateActive,
  locationsFetchRegisterAsync,
  locationsChangeFieldValue,
  locationsUpdateFilter,
  userSessionMenuItemActive,
}: IProps) => {
  const tokenService = new TokenService();
  const router = useNavigate();
  const TITLE_PAGE = useTranslation({ id: "unit" });

  useEffect(() => {
    userSessionMenuItemActive(MenuItemActive.UNITS);
    tokenService.authenticateToken();
  }, []);

  useEffect(() => {
    return () => {
      locationsUpdateFilter(null);
    };
  }, []);

  const redirectToCreateLocation = () => {
    router("/private/location/form");
    userSessionMenuItemActive(MenuItemActive.LOCATION);
    locationsCreateActive(true);
  };

  return (
    <Layout title={TITLE_PAGE} isLoading={isLoading} role={userData.role}>
      <S.DefaultContainer>
        <S.HeaderContainer>
          <RegisterButton id="create-location" title="new_location" dataTestId="createLocation" onClick={redirectToCreateLocation} />
          <LocationFilter locationUpdateFilter={locationsUpdateFilter} locationChangeFieldValue={locationsChangeFieldValue} />
        </S.HeaderContainer>
        <LocationGrid
          items={items}
          totalItems={totalItems}
          locationsChangeFieldValue={locationsChangeFieldValue}
          locationsFetchRegisterAsync={locationsFetchRegisterAsync}
          searchFilter={searchFilter}
          pageIndex={pageIndex}
          isLoadingTable={isLoadingTable}
          userSessionMenuItemActive={userSessionMenuItemActive}
        />
      </S.DefaultContainer>
    </Layout>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...LocationActions, ...UserSessionActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Location.isLoading,
  userData: state.UserSession.userData,
  items: state.Location.items,
  totalItems: state.Location.totalItems,
  searchFilter: state.Location.searchFilter,
  pageIndex: state.Location.filter.pageIndex,
  isLoadingTable: state.Location.isLoadingTable,
});
export default connect(mapStateToProps, mapDispatchToActions)(Location);
